module.exports = __webpack_public_path__ + "media/images/left_arrow-54be8f296dea2c0bccf17c2dd0d6cc11.svg";